import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon-rotate" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1)

import {
  reactive,
} from 'vue';
import Expansion from '@/components/Expansion.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'Expand',
  props: {
  title: {
    type: String,
    required: true,
  },
  expanded: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  type: {
    type: String,
    required: false,
    default: () => 'default',
  },
},
  setup(__props) {

library.add(faChevronDown);

const props = __props;

const component = reactive({
  expanded: props.expanded,
});

const toggle = () => {
  component.expanded = !component.expanded;
};

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["expand", { 'expanded': component.expanded }])
  }, [
    _createElementVNode("button", { onClick: toggle }, [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_FontAwesomeIcon, { icon: "fa-solid fa-chevron-down" })
      ]),
      _createElementVNode("span", { innerHTML: __props.title }, null, 8, _hoisted_2),
      _hoisted_3
    ]),
    _createVNode(Expansion, {
      expanded: component.expanded
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["expanded"])
  ], 2))
}
}

})